interface InterventionWithId {
  id?: number | null
}

export function hasSelectedIntervention(intervention?: InterventionWithId | null): boolean {
  return intervention?.id !== undefined && intervention?.id !== null
}
